import { Flex, Text, ListItem } from '@chakra-ui/react'
import { useGetUserProfileByAddress } from '@/api/query'
import { FiatOrCryptoAmount } from '@/components/atoms/Amount/Amount'
import { AvatarCircle } from '@/components/atoms/Avatar'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { GradientText } from '@/components/atoms/GradientText/GradientText'
import { TokenMoney } from '@ninjablaze/sdk-ts'

export const UserBet = ({ address, amount, denom }: { address: string; amount: string; denom: string }) => {
  const { data: profile } = useGetUserProfileByAddress(address)
  const modal = useAppModal()
  const numberOfNfts = profile?.nfts?.totalCount
  const isNftOwner = Boolean(numberOfNfts)

  const value = new TokenMoney(amount, denom)

  return (
    <ListItem
      mb={3}
      _last={{
        mb: 0,
      }}
    >
      <Flex justifyContent={'space-between'}>
        <Flex alignItems={'center'} gap={1.5}>
          <AvatarCircle
            cursor={'pointer'}
            onClick={() => modal.openModalNew(AppModals.UserStats, { address })}
            size={'xs'}
            boxShadow={isNftOwner ? '0px 0px 10px 0px #5D52EE;' : 'none'}
            offset={3}
            src={profile?.user?.profileAvatar}
          />
          {isNftOwner ? (
            <GradientText
              numberOfNfts={numberOfNfts!}
              props={{
                fontWeight: 700,
                fontSize: 'sm',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxW: { base: 'none', md: '40px', xl: 'none' },
              }}
            >
              {profile?.user?.profileUserName}
            </GradientText>
          ) : (
            <Text
              maxW={{ base: 'none', md: '40px', xl: 'none' }}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              fontSize={'sm'}
              fontWeight={700}
              whiteSpace={'nowrap'}
            >
              {profile?.user?.profileUserName}
            </Text>
          )}
        </Flex>
        <FiatOrCryptoAmount
          wrapperStyles={{
            fontSize: 'sm',
          }}
          iconSize={'18px'}
          value={value}
          denom={denom}
        />
      </Flex>
    </ListItem>
  )
}
